import React, { Component } from "react";
import { Link } from "react-router";
import { Helmet } from "react-helmet";

import "./assets/style.scss";

import P1s from "./assets/p1s.webp";
import P1 from "./assets/p1.webp";
import P1sPNG from "./assets/p1s.png";
import P1PNG from "./assets/p1.png";
import P2s from "./assets/p2s.webp";
import P2 from "./assets/p2.webp";
import P2sPNG from "./assets/p2s.png";
import P2PNG from "./assets/p2.png";
import P3s from "./assets/p3s.webp";
import P3 from "./assets/p3.webp";
import P3sPNG from "./assets/p3s.png";
import P3PNG from "./assets/p3.png";
import P4s from "./assets/p4s.webp";
import P4 from "./assets/p4.webp";
import P4sPNG from "./assets/p4s.png";
import P4PNG from "./assets/p4.png";

import Artist1 from "./assets/clients/rehab.jpg";
import Artist2 from "./assets/clients/naaz.jpg";
import Artist3 from "./assets/clients/heldens.jpg";
import Artist4 from "./assets/clients/ronnie_flex.jpg";
import Artist5 from "./assets/clients/glasperlenspiel.jpg";
import Artist6 from "./assets/clients/di-rect.jpg";
import Artist7 from "./assets/clients/armin.jpg";
import Artist8 from "./assets/clients/blof.jpg";
import Artist9 from "./assets/clients/afrojack.jpg";
import Artist10 from "./assets/clients/bizzey.jpg";
import Artist11 from "./assets/clients/showtek.jpg";

import Logo from "./assets/logo.png";

import MobilesPNG from "./assets/mobiles.png";
import MobilePNG from "./assets/mobile.png";
import Mobiles from "./assets/mobiles.webp";
import Mobile from "./assets/mobile.webp";

import AppStore from "./assets/app_store.png";
import PlayStore from "./assets/play_store.png";

export default class Artist extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="aboss__artist">
        <Helmet>
          <title>
            ABOSS Artist - Organize your data, streamline your back office and
            collaborate with your team
          </title>
          <meta
            name="description"
            content="ABOSS Artist is the ultimate tool to manage your day-to-day activities as an artist."
          />
        </Helmet>
        <picture>
          <source srcSet={`${P1s} 1x, ${P1} 2x`} type="image/webp" />
          <source srcSet={`${P1sPNG} 1x, ${P1PNG} 2x`} type="image/png" />
          <img src={P1s} className="aboss__artist-phone-one" alt="ABOSS App" />
        </picture>
        <picture>
          <source srcSet={`${P2s} 1x, ${P2} 2x`} type="image/webp" />
          <source srcSet={`${P2sPNG} 1x, ${P2PNG} 2x`} type="image/png" />
          <img src={P2s} className="aboss__artist-phone-two" alt="ABOSS App" />
        </picture>
        <picture>
          <source srcSet={`${P3s} 1x, ${P3} 2x`} type="image/webp" />
          <source srcSet={`${P3sPNG} 1x, ${P3PNG} 2x`} type="image/png" />
          <img
            src={P3s}
            className="aboss__artist-phone-three"
            alt="ABOSS App"
          />
        </picture>
        <picture>
          <source srcSet={`${P4s} 1x, ${P4} 2x`} type="image/webp" />
          <source srcSet={`${P4sPNG} 1x, ${P4PNG} 2x`} type="image/png" />
          <img src={P4s} className="aboss__artist-phone-four" alt="ABOSS App" />
        </picture>
        <div className="aboss__artist-intro">
          <div className="aboss__artist-intro-content">
            <img
              src={Logo}
              className="aboss__artist-intro-content-logo"
              alt="ABOSS Logo"
            />
            <h1>Artist</h1>
            <h2>
              Organize your data, streamline your back office and collaborate
              with your team
            </h2>
            <div className="aboss__artist-intro-content-actions">
              <a href="https://abossmusic.com/artist/trial">
                <button className="blue">Start your free trial</button>
              </a>
            </div>
          </div>
          <div className="aboss__artist-intro-references">
            <div className="aboss__artist-intro-references-content">
              <h1>You'll join an amazing roster</h1>
              <p>
                Trusted and loved by some of the world's most talented artists.
              </p>
            </div>
            <div className="aboss__artist-intro-references-clients">
              <div className="aboss__artist-intro-references-clients-row">
                <div>
                  <img src={Artist1} alt="R3hab" />
                  <span>R3hab</span>
                </div>
                <div>
                  <img src={Artist2} alt="Naaz" />
                  <span>Naaz</span>
                </div>
                <div>
                  <img src={Artist3} alt="Oliver Heldens" />
                  <span>Oliver Heldens</span>
                </div>
                <div>
                  <img src={Artist4} alt="Ronnie Flex" />
                  <span>Ronnie Flex</span>
                </div>
                <div>
                  <img src={Artist5} alt="Glasperlenspiel" />
                  <span>Glasperlenspiel</span>
                </div>
              </div>
              <div className="aboss__artist-intro-references-clients-row">
                <div>
                  <img src={Artist6} alt="Di-rect" />
                  <span>Di-rect</span>
                </div>
                <div>
                  <img src={Artist7} alt="Armin van Buuren" />
                  <span>Armin van Buuren</span>
                </div>
                <div>
                  <img src={Artist8} alt="Bløf" />
                  <span>Bløf</span>
                </div>
                <div>
                  <img src={Artist9} alt="Afrojack" />
                  <span>Afrojack</span>
                </div>
                <div>
                  <img src={Artist10} alt="Bizzey" />
                  <span>Bizzey</span>
                </div>
                <div>
                  <img src={Artist11} alt="Showtek" />
                  <span>Showtek</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="aboss__artist-features">
          <div className="aboss__artist-features-content">
            <div className="aboss__artist-features-content-row">
              <div className="aboss__artist-features-content-row-image calendar"></div>
              <div className="aboss__artist-features-content-row-content">
                <div className="aboss__artist-features-content-icon calendar">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="4"
                      width="18"
                      height="18"
                      rx="2"
                      ry="2"
                    ></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <h1>Calendar</h1>
                <ul>
                  <li>
                    The calendar is the heart of your career and the single
                    source of truth for all stakeholders that are involved in
                    your day to day activities.
                    <br />
                    <br />
                    ABOSS is designed to give everyone around the artist their
                    own personal view in the calendar on a need to know basis.
                    Block parts of your calendar to tune out and/or reserve time
                    for uninterrupted quality time with family and friends.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <ul className="aboss__artist-features-list">
            <li className="calendar-label">
              <h2>Custom color coded & smart labels</h2>
              <p>
                Create your own custom labels and assign a specific color to
                each label for a clear overview in the calendar. This way you
                can easily see if your activities match the priorities you set
                for your career and/or health.
              </p>
              <p>
                Use our smart labels to distinguish the different career
                activities by color and type.
              </p>
            </li>
            <li className="calendar-ics">
              <h2>Connect to Google Calendar or iCal</h2>
              <p>
                Connect your calendar with your preferred calendar software tool
                so each team member will receive the information realtime in
                their personal calendar, based on the permissions they have
                within your ABOSS account.
              </p>
            </li>
          </ul>
          <ul className="aboss__artist-features-list">
            <li className="calendar-items">
              <h2>
                Meetings, studio-time, events and travel items, all in a single
                calendar
              </h2>
              <p>
                Have team add upcoming shows and career activities directly in
                your ABOSS calendar and automatically share your business
                meetings, studio sessions, social posts and writing sessions,
                within your team on a need to know basis.
              </p>
            </li>
            <li className="calendar-social">
              <h2>
                Publish your upcoming tour dates on your website, Facebook &
                Bandsintown
              </h2>
              <p>
                Keeping track of your finance is the essential to be able
                flourish your career as an artist long term. ABOSS supports you
                in every step of the way; build your deals for each event,
                monitor your potential upside, generate invoices automatically
                from your deals and keep a clear overview of your overall
                finances.
              </p>
            </li>
          </ul>

          <div className="aboss__artist-features-content">
            <div className="aboss__artist-features-content-row">
              <div className="aboss__artist-features-content-row-image finance"></div>
              <div className="aboss__artist-features-content-row-content">
                <div className="aboss__artist-features-content-icon finance">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                </div>
                <h1>Finance</h1>
                <ul>
                  <li>
                    Keeping track of your finance is the essential to be able
                    flourish your career as an artist long term.
                    <br />
                    ABOSS supports you in every step of the way; build your
                    deals for each event, monitoring your potential upside,
                    generate invoices automatically from your deals and keep a
                    clear overview of your overall finances.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul className="aboss__artist-features-list">
            <li
              className="aboss__artist-features-list-column"
              style={{ flex: "2" }}
            >
              <ul>
                <li className="finance-deal">
                  <h2>Custom deals for each event</h2>
                  <p>
                    Create your own deals for each event and export
                    automatically calculated statements that includes all the
                    information you need; gross fee, booking fees, commissions,
                    potential upside, withholding tax and costs.
                  </p>
                </li>
                <li className="finance-overview">
                  <h2>Financial overview</h2>
                  <p>
                    Get a clear and detailed overview, (potential) revenue and
                    costs for all your career activities in a specific period of
                    time and for specific projects. Export financial statements
                    and forecasts and get more insight to manage your cashflow.
                  </p>
                </li>
              </ul>
            </li>
            <li className="finance-invoices">
              <h2>Generate invoices</h2>
              <p>
                Create and send your personal branded invoices and keep track on
                status of payments. ABOSS can automatically generate all the
                information based on your deals, making sure you'll always
                invoice what's needed.
              </p>
              <p>
                Have your accountant export your invoice data in excel, export
                all sent invoices as pdf files or connect to your accounting
                software .
              </p>
            </li>
          </ul>
          <div className="aboss__artist-features-content">
            <div className="aboss__artist-features-content-row">
              <div className="aboss__artist-features-content-row-image advancing"></div>

              <div className="aboss__artist-features-content-row-content">
                <div className="aboss__artist-features-content-icon advancing">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="18" cy="18" r="3"></circle>
                    <circle cx="6" cy="6" r="3"></circle>
                    <path d="M13 6h3a2 2 0 0 1 2 2v7"></path>
                    <line x1="6" y1="9" x2="6" y2="21"></line>
                  </svg>
                </div>
                <h1>Production & logistics</h1>
                <ul>
                  <li>
                    Manage all your production, tech and logistic information
                    for each event in ABOSS and share directly with involved
                    team members.
                    <br />
                    All information is automatically synced within ABOSS, the
                    ABOSS App, Google/iCal calendars and they can download an
                    always-up-to-date itinerary in PDF format.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <ul className="aboss__artist-features-list">
            <li className="advancing-dashboard">
              <h2>Advancing progress dashboard</h2>
              <p>
                A detailed overview of progress on each event for the
                production, tech and logistic information flow between
                tourmanager and venue. You can see in one glance what specific
                information needs to be chased and you will have peace of mind
                when the pre-production is completed.
              </p>
            </li>
            <li className="advancing-travel">
              <h2>Add travel items</h2>
              <p>
                Organise flights, hotels and ground transportation in your
                calendar for a full and up to date travel itinerary. We also
                offer free integrations with Holcar Travel and Munckhof.
              </p>
            </li>
          </ul>
          <ul className="aboss__artist-features-list">
            <li className="advancing-request">
              <h2>Request info from third parties</h2>
              <p>
                Going crazy of all the boring copy and paste actions from your
                email into the itinerary? Send out your link with all required
                information to the promoter and approve feedback without any
                additional e-mails. Once approved the information is directly
                shared with all team members involved. This way data only is
                only entered once, instead of multiple times on multiple places
                bu multiple people in multiple ways.
              </p>
            </li>
          </ul>
          <div className="aboss__artist-features-content">
            <div className="aboss__artist-features-content-row">
              <div className="aboss__artist-features-content-row-image data"></div>
              <div className="aboss__artist-features-content-row-content">
                <div className="aboss__artist-features-content-icon data">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                  </svg>
                </div>
                <h1>Organise your own data</h1>

                <ul>
                  <li>
                    Being able to steer your career in the direction you want
                    starts with building up knowledge about your past and
                    current situation. ABOSS makes it easy to automatically
                    build up your history on all your contacts, locations,
                    calendar activities and related finance. Always have insight
                    from your historical data whenever you need to make
                    important decisions for career moves.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul className="aboss__artist-features-list">
            <li className="data-availability">
              <h2>Build network history</h2>
              <p>
                ABOSS automatically builds up your contact history when people
                are linked to career activities in the calendar (producers,
                recording engineers, musicians, live crew, press, publishers,
                record label, fans, etc)
              </p>
            </li>
            <li className="data-contacts">
              <h2>Contact database</h2>
              <p>
                Built your network with relevant contacts and store their
                information, files, contact details and history for future
                reference. Label your contacts to be able to search, filter and
                export specific campaigns contact lists at any time.
              </p>
            </li>
            <li className="data-locations">
              <h2>Location database</h2>
              <p>
                Build your location database to have standard info of the
                location pushed into the advancing area automatically when
                selecting a specific venue for an event. Our Google maps
                integration makes it easy to find locations that are not
                available in your database yet.
              </p>
            </li>
          </ul>
          <ul className="aboss__artist-features-list">
            <li className="collaboration">
              <h2>
                Connect with agencies, travel agents and management accounts
              </h2>
              <p>
                Connect with booking or management agency accounts to share
                available dates, career activities and collaborate on shows for
                production. When connected to an agency you’ll receive realtime
                financial statements as shows are being booked.
              </p>
              <p className="read-more">
                Read more about sharing <span>SOON</span>
              </p>
            </li>
          </ul>
          <div className="aboss__artist-features-content">
            <div className="aboss__artist-features-content-row">
              <div className="aboss__artist-features-content-row-image team"></div>
              <div className="aboss__artist-features-content-row-content">
                <div className="aboss__artist-features-content-icon permissions">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      width="18"
                      height="11"
                      rx="2"
                      ry="2"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                  </svg>
                </div>
                <h1>Team & permissions</h1>
                <ul>
                  <li>
                    You decide who has access to what information with the
                    permission module in ABOSS. Assign specific permissions to
                    team members on areas (contacts, finance, advancing...) or
                    have users only view the activities and projects they
                    participate in.
                    <br />
                    <br />
                    Users are unlimited without additional costs. Have your
                    manager manage the calendar, accountant manage your invoices
                    and financial statements and your tour manager manage
                    production and logistics.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ul className="aboss__artist-features-list">
          <li>
            <h2>Calendar access on a need-to-know basis</h2>
            <p>
              Each user’s permissions can be setup in different layers for the
              calendar so you decide who gets to see and do what within your
              your calendar. Some musicians only play certain concerts or some
              producers only attend specific studio sessions, so no need for
              them to see the full calendar. This makes it possible for them to
              link your calendar to their own personal Google/iCal calendar so
              they are always up to date without any unnecessary noise.
            </p>
          </li>
          <li>
            <h2>Request availability</h2>
            <p>
              Plan and invite contacts to career activities and request their
              availability, even when they aren’t a user in your account; crew
              to shows, musicians for studio sessions, team members to meetings.
              See the total overview for planning and status of all invited
              contacts for the full calendar.
            </p>
          </li>
          <li>
            <h2>Tasks & reminders</h2>
            <p>
              Plan tasks and reminders in the calendar and link users to them.
              When the calendar is connected to your iCal or Google calendar
              you’re able to receive automatic notifications on your device when
              deadlines arrive.
            </p>
          </li>
        </ul>

        <div className="aboss__artist-mobile">
          <div>
            <picture>
              <source
                srcSet={`${Mobiles} 1x, ${Mobile} 2x`}
                type="image/webp"
              />
              <source
                srcSet={`${MobilesPNG} 1x, ${MobilePNG} 2x`}
                type="image/png"
              />
              <img src={Mobiles} alt="ABOSS iOS & Android app" />
            </picture>
          </div>
          <div>
            <div className="aboss__influencers-blocks-block-content">
              <h2>Mobile App</h2>
              <h1>All information available in your pocket</h1>
              <p>
                With the many professionals involved in your company and career
                there should only be 1 source of truth for everyone involved.
                With the mobile app your team is always up to date and can
                access the information even when they’re in offline mode. When
                set with the right permissions it’s possible to update
                information while on the road.
              </p>
              <div className="aboss__influencers-blocks-block-content-store">
                <a href="https://itunes.apple.com/us/app/aboss/id1048993502?ls=1&mt=8">
                  <img
                    src={AppStore}
                    className="appstore"
                    alt="Apple App Store"
                  />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.aboss">
                  <img
                    src={PlayStore}
                    className="playstore"
                    alt="Google Play Store"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="aboss__artist-trial">
          <h1>Start your free trial today</h1>
          <a href="https://abossmusic.com/artist/trial">
            <button className="blue">Start your free trial</button>
          </a>
          <ul>
            <li>Free for 14 days</li>
            <li>No credit card needed</li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/products/artist/index.js